import styles from "./AngeboteKarte.module.css";

function AngeboteKarte({ title, price, body, pdf }) {
  return (
    <div className={styles.angeboteKarteContainer}>
      <p className={styles.countryTitle}>{title}</p>
      <div className={styles.priceContainer}>
        <p className={styles.priceTitle}>ab</p>
        <p className={styles.priceValue}>{price}</p>
      </div>
      <p className={styles.priceDescription}>
        die Preise beziehen sich auf p. P.
      </p>
      <p className={styles.body}>{body}</p>
      <div className={styles.button} role="button">
        <a href={pdf} download={title}>
          Hier PDF holen
        </a>
      </div>
    </div>
  );
}

export default AngeboteKarte;
